import * as request from 'services/request'
import { notification as notify } from 'utils'

/* A regular expression representing a valid Google Sheet URL. A string is used
 * to construct the Regex because the eslint package used in this project does
 * not support named capture groups, and too many problems arise from upgrading
 * the eslint package(s) which are out of scope to fix as part of this feature.
 */
const GOOGLE_SHEET_URL_PATTERN_STRING =
  '^(https://docs.google.com/spreadsheets/d/)(?<spreadsheetId>[a-zA-Z0-9-_]+)(/edit)?(#gid=(?<sheetId>\\d+))?$'
export const GOOGLE_SHEET_URL_PATTERN = new RegExp(
  GOOGLE_SHEET_URL_PATTERN_STRING
)

export const startWidget = ({ id, widgetData: { name, status } }) => {
  const newStatus = status === 'draft' ? 'active' : status

  return request
    .authorized(`/widgets/${id}/status`, {
      method: 'PUT',
      body: {
        status: newStatus
      }
    })
    .then(() => {
      notify.success({
        message: `Experience '${name}' started!`
      })
    })
    .catch(e => {
      notify.error({
        title: `Failed to start experience "${name}"`,
        message: e.message
      })
    })
}

export const notifyError = (e, name) => {
  const error = e.message.split(': ')
  if (e.message.startsWith('400')) {
    notify.error({
      title: 'Invalid configuration',
      message:
        'Please confirm that you have configured all the fields correctly'
    })
  } else if (error[0].startsWith('422')) {
    notify.error({
      title: 'Validation error',
      message: error[1]
    })
  } else {
    notify.error({
      title: `Failed to save experience "${name}"`,
      message: e.message
    })
  }
}



// WEBPACK FOOTER //
// ./src/pages/widgets/util.js